import { BrowserRouter, Route, Routes } from 'react-router-dom';
import useVH from 'react-viewport-height';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Technologies from './pages/Technologies/Technologies';
import Projects from './pages/Projects/Projects';
import Contact from './pages/Contact/Contact';
import "./custom.scss";

export default function App() {

  useVH();

  return (
    <div className="App app-padding d-block d-md-flex justify-content-center align-items-center">
        <div className="envelop-primary-container bg-beige border border-primary p-2">
          
          <div className="d-flex flex-row bd-highlight mb-1">
            <div style={{ width: "2.5%" }}>
              <div className="envelop-line"></div>
              <div className="envelop-line"></div>
              <div className="envelop-line"></div>
            </div>
            <div className="square ms-1" style={{ minWidth: "2%" }}></div>
            <div className="ms-1" style={{ width: "96.3%" }}>
              <div className="envelop-line"></div>
              <div className="envelop-line"></div>
              <div className="envelop-line"></div>
            </div>
            <div className="close ms-1">x</div>
          </div>
    
          <div className="envelop-secondary-container border border-primary">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route path="technologies" element={<Technologies />} />
                  <Route path="projects" element={<Projects />} />
                  <Route path="contact" element={<Contact />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </div>
    
          <div className="envelop-line mt-1"></div>
    
        </div>
    </div>
  );
}